import { createSlice } from "@reduxjs/toolkit";

export interface InvoicesState {
  loading: boolean;
  listLoading: boolean;
  actionsLoading: boolean;
  error: null;
  page: number;
  total: number;
  size: number;
  invoices: any;
  invoiceForEdit: any;
  totalCount: number;
  invoiceLogs: any;
  invoiceLogsCount: Number;
  totalLogsCount: Number;
}

const initialInvoicesState: InvoicesState = {
  loading: false,
  listLoading: false,
  actionsLoading: false,
  error: null,
  page: 0,
  total: 0,
  size: 0,
  invoices: [],
  invoiceForEdit: {},
  totalCount: 0,
  invoiceLogs: [],
  invoiceLogsCount: 0,
  totalLogsCount: 0,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const invoicesSlice = createSlice({
  name: "invoices",
  initialState: initialInvoicesState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.loading = true;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = true;
      }
    },
    // get filtered invoices

    getFilteredInvoices: (state, action) => {
      const { allInvoices, total, page, size } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.loading = false;
      state.invoices = allInvoices;
      state.total = total;
      state.page = page;
      state.size = size;
    },
    invoiceLogs: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.invoiceLogs = action.payload.logs;
      state.invoiceLogsCount = action.payload.invoiceLogsCount;
      state.totalLogsCount = action.payload.totalLogsCount;
    },

    //  getContentById: (state, action) => {
    //    const { contentToEdit } = action.payload;
    //    state.actionsLoading = false;
    //    state.error = null;
    //    state.loading = false;
    //    state.contentForEdit = contentToEdit;
    //  },
    //  updateContentById: (state, action) => {
    //    const { contentForEdit } = action.payload;
    //    state.actionsLoading = false;
    //    state.error = null;
    //    state.loading = false;
    //    state.contentForEdit = contentForEdit;
    //  },

    //  setSelectedModule: (state, action) => {
    //    state.selectedModule = action.payload;
    //  },
  },
});
